export default [
    { key: 'new', label: 'New' },
    { key: 'prepared', label: 'Prepared' },
    { key: 'processing', label: 'Processing' },
    { key: 'closed', label: 'Closed' },
    { key: 'cancelled', label: 'Cancelled' },
    { key: 'failure', label: 'Failure' },
];
